module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ../~/iframe-resizer/index.js
// module id = 999
// module chunks = 0